import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Base_Url, registerapi } from "../config/config";
import AOS from 'aos';
import 'aos/dist/aos.css';
import RateCalculator from "./Register/RateCalculator";
import RegisterPanelCarousel from "./Register/RegisterPanelCrousel";
import PartnerCarousel from "./Register/PartnerCarousel";

AOS.init({ once: true });
const stats = [
    { value: "₹30", label: "Starting Price", sub: "Per Shipment" },
    { value: "0", label: "Min. Order Value", sub: "No Minimums" },
    { value: "50%", label: "Lower Rates", sub: "Heavy Parcels" },
    { value: "FREE", label: "COD Remittance", sub: "Zero Extra Cost" },
];

const features = [
    { icon: "🚀", title: "Express Delivery", desc: "Same-day & next-day delivery across 29,000+ pin codes" },
    { icon: "📦", title: "B2B & E-Commerce", desc: "Tailored solutions for businesses of all sizes" },
    { icon: "🕐", title: "24×7 Support", desc: "Our team is always on — day, night, weekends" },
    { icon: "📍", title: "Live Tracking", desc: "Real-time updates at every step of the journey" },
];

const RegisterHerosection = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
        company: "",
        email: "",
        mobile: "",
        password: ""
    });

    const [showPass, setShowPass] = useState(false);
    const [focused, setFocused] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        let { name, value } = e.target;

        // same filtering logic (1st code se)
        if (name === "mobile") {
            value = value.replace(/[^0-9]/g, "");
        }
        if (name === "name") {
            value = value.replace(/[^a-zA-Z\s]/g, "");
        }

        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async () => {
        const { name, email, mobile, password } = formData;

        // basic validation
        if (!name || !email || !mobile || !password) {
            toast.error("Please fill all required fields");
            return;
        }

        if (password.length < 8) {
            toast.error("Password must be at least 8 characters");
            return;
        }

        try {
            setLoading(true);

            const res = await axios.post(Base_Url + registerapi, {
                name: formData.name,
                email: formData.email,
                phone: formData.mobile,
                password: formData.password,
                address: "",
                company_name: formData.company
            });

            setLoading(false);

            if (res.data.status === "SUCCESS") {
                toast.success("Signup successful!");
                navigate("/updateKYc");
            } else {
                toast.error(
                    res.data.message?.phone ||
                    res.data.message?.email ||
                    res.data.message?.password ||
                    "Something went wrong"
                );
            }

        } catch (err) {
            setLoading(false);
            toast.error("Signup failed!");
        }
    };

    return (
        <>
            <div className="min-h-screen bg-white text-black font-sans overflow-x-hidden">
                <div className="fixed inset-0 pointer-events-none overflow-hidden">
                    <div className="absolute top-[-10%] left-[-5%] w-[500px] h-[500px] rounded-full bg-orange-500/10 blur-[120px] animate-pulse" />
                    <div className="absolute bottom-[-10%] right-[-5%] w-[600px] h-[600px] rounded-full bg-blue-600/10 blur-[140px] animate-pulse" style={{ animationDelay: "1.5s" }} />
                    <div className="absolute top-[40%] left-[40%] w-[300px] h-[300px] rounded-full bg-orange-400/5 blur-[80px]" />
                </div>

                <div className="relative z-10 max-w-max mx-auto px-6 md:px-12 lg:px-16 py-16 grid lg:grid-cols-2 gap-6 items-start">

                    {/* LEFT */}
                    <div data-aos="fade-right" data-aos-duration="1000" className="flex flex-col gap-10">
                        {/* Badge */}
                        <div className="inline-flex items-center gap-2 w-fit px-4 py-2 rounded-full bg-orange-500/10 border border-orange-500/20">
                            <span className="w-2 h-2 rounded-full bg-orange-400 animate-pulse" />
                            <span className="text-orange-400 text-sm font-medium">India's Fastest Growing Logistics</span>
                        </div>

                        {/* Hero heading */}
                        <div>
                            <h1 className="text-4xl md:text-5xl font-black leading-[1.05] tracking-tight">
                                <span className="text-black">Shipped More</span><br />
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">
                                    Than 1 Crore
                                </span><br />
                                <span className="text-black">Packets</span>
                                <span className="text-black"> Last Quarter</span>
                            </h1>
                            <p className="mt-5 text-gray-700 text-lg leading-tight max-w-[480px]">
                                The fastest-growing logistics company serving B2B & E-commerce.
                                Best-in-class team with <strong className="text-black font-medium">24×7 customer support</strong> — always on, always ready.
                            </p>
                        </div>

                        {/* Stats grid */}
                        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                            {stats.map((s) => (
                                <div key={s.label} className="rounded-2xl border border-gray-400 bg-white/[0.04] p-4 hover:bg-white/[0.07] hover:border-gray-800 transition-all duration-300">
                                    <div className="text-2xl font-black text-orange-400">{s.value}</div>
                                    <div className="text-black text-[9.5px] font-semibold mt-1 uppercase tracking-wider leading-tight">{s.label}</div>
                                    <div className="text-black text-[11px] mt-0.5">{s.sub}</div>
                                </div>
                            ))}
                        </div>

                        {/* Feature list */}
                        <div className="grid sm:grid-cols-2 gap-4">
                            {features.map((f) => (
                                <div key={f.title} className="flex gap-3 items-start p-4 rounded-2xl bg-white/[0.03] border border-gray-400 hover:border-gray-800 hover:bg-white/[0.06] transition-all duration-300">
                                    <span className="text-2xl">{f.icon}</span>
                                    <div>
                                        <div className="text-black font-semibold text-sm">{f.title}</div>
                                        <div className="text-black text-xs mt-0.5 leading-tight">{f.desc}</div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Illustration strip */}
                        <div className="relative rounded-3xl overflow-hidden border  border-black  p-6 flex items-center gap-6">
                            <div className="text-[72px] leading-none ">🚚</div>
                            <div>
                                <div className="text-black font-bold text-xl">Ship smarter, deliver faster</div>
                                <div className="text-black text-sm mt-1">Join 50,000+ businesses already on PickupXpress</div>
                            </div>
                            <div className="absolute top-4 right-6 text-[32px]">⏱️</div>
                            <div className="absolute bottom-3 right-14 text-[24px] ">📦</div>
                        </div>
                    </div>


                    {/* RIGHT — Signup Card */}
                    <div className="lg:sticky lg:top-8">
                        <div className="rounded-3xl border border-gray-400 bg-gray-100 p-8 shadow-2xl">

                            <div className="flex items-center justify-between mb-8">
                                <div>
                                    <h2 className="text-black font-bold text-2xl">Create Account</h2>
                                    <p className="text-gray-500 text-sm mt-1">Signup to PICKUPXPRESS</p>
                                </div>
                                <img src="assets/images/logo1.png" alt="Logo" className=" w-48 rounded-sm" />
                            </div>

                            {/* FORM */}
                            <div className="flex flex-col gap-4">

                                {[
                                    { name: "name", placeholder: "Full Name", type: "text" },
                                    { name: "company", placeholder: "Company Name", type: "text" },
                                    { name: "email", placeholder: "Email Address", type: "email" },
                                    { name: "mobile", placeholder: "Mobile Number", type: "tel" },
                                ].map((field) => (
                                    <input
                                        key={field.name}
                                        type={field.type}
                                        name={field.name}
                                        value={formData[field.name]}
                                        onChange={handleChange}
                                        placeholder={field.placeholder}
                                        className="border px-4 py-3 rounded-xl outline-none"
                                    />
                                ))}

                                {/* PASSWORD */}
                                <div className="flex items-center border px-4 py-3 rounded-xl">
                                    <input
                                        type={showPass ? "text" : "password"}
                                        name="password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        placeholder="Password"
                                        className="flex-1 outline-none"
                                    />
                                    <button onClick={() => setShowPass(!showPass)}>
                                        {showPass ? <Eye /> : <EyeOff />}
                                    </button>
                                </div>

                                {/* SUBMIT BUTTON */}
                                <button
                                    onClick={handleSubmit}
                                    disabled={loading}
                                    className="mt-2 w-full py-4 rounded-xl bg-red-500 text-white font-bold"
                                >
                                    {loading ? "Creating..." : "Create Account →"}
                                </button>

                                <p className="text-center text-gray-700 text-xs mt-1">
                                    Already have an account?{" "}
                                    <Link to="/login" className="text-orange-400 font-medium">
                                        Log in
                                    </Link>
                                </p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <PartnerCarousel/>
            <RegisterPanelCarousel/>
            <RateCalculator/>
        </>
    );
};

export default RegisterHerosection;